export default function EFOven(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M24.5 4H7.5C6.67157 4 6 4.67157 6 5.5V26.5C6 27.3284 6.67157 28 7.5 28H24.5C25.3284 28 26 27.3284 26 26.5V5.5C26 4.67157 25.3284 4 24.5 4Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M9 7H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="22" cy="7" r="1" fill="currentColor" />
            <path
                d="M21.5 13H10.5C9.67157 13 9 13.6716 9 14.5V23.5C9 24.3284 9.67157 25 10.5 25H21.5C22.3284 25 23 24.3284 23 23.5V14.5C23 13.6716 22.3284 13 21.5 13Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.1 16L13.9018 17.1455C14.2478 17.6397 14.189 18.311 13.7624 18.7376V18.7376C13.325 19.175 13.2757 19.8676 13.647 20.3626L14.5 21.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M17.1 16L17.9018 17.1455C18.2478 17.6397 18.189 18.311 17.7624 18.7376V18.7376C17.325 19.175 17.2757 19.8676 17.647 20.3626L18.5 21.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path d="M6 10H26" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
